import type { IconData } from '@stacksjs/iconify-core'

export const imageSaturation: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M6 27.889C6 17.782 17.874 7.674 22.334 4.234a2.714 2.714 0 0 1 3.332 0C30.126 7.674 42 17.782 42 27.89C42 37.339 33.941 45 24 45S6 37.34 6 27.889\"/><path d=\"M23.232 12.57a.477.477 0 0 1 .768.39V37c0 .552-.45 1.005-1 .957c-5.606-.486-10-5.024-10-10.55c0-6.46 7.734-12.919 10.232-14.837\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default imageSaturation
